import { render, staticRenderFns } from "./Workbench.vue?vue&type=template&id=9de03c62&scoped=true"
import script from "./Workbench.vue?vue&type=script&lang=js"
export * from "./Workbench.vue?vue&type=script&lang=js"
import style0 from "./Workbench.vue?vue&type=style&index=0&id=9de03c62&prod&lang=scss"
import style1 from "./Workbench.vue?vue&type=style&index=1&id=9de03c62&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9de03c62",
  null
  
)

export default component.exports